import React from 'react';
import { Box } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { StyledBoxTrusted, StyledFade } from './helperComponents';

const SlideDesktopAndTablet: React.FC = () => (
  <Box
    w="100%"
    h="500px"
    position="relative"
    d={{ base: 'none', tablet: 'flex' }}
  >
    <Box
      bg="neutral.0"
      position="absolute"
      left="-40px"
      top={0}
      w="42px"
      zIndex={200}
      h="100%"
    />
    <StyledFade
      w="100%"
      justifyContent="center"
      alignItems="center"
      position="relative"
      h="100%"
      overflow="hidden"
    >
      <StaticImage
        placeholder="blurred"
        style={{ maxHeight: 370, minWidth: 370 }}
        width={370}
        height={370}
        alt="vector"
        src="../../../assets/images/home_page_trusted_vector.png"
      />
      <StyledBoxTrusted left={70} top={190} width={70} delayTime={0} time={14}>
        <StaticImage
          placeholder="blurred"
          objectFit="contain"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_5.png"
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={145}
        top={330}
        width={145}
        delayTime={3}
        time={14}
      >
        <StaticImage
          placeholder="blurred"
          objectFit="contain"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_3.png"
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={120}
        top={102}
        width={120}
        delayTime={4}
        time={14}
      >
        <StaticImage
          placeholder="blurred"
          objectFit="contain"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_6.png"
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={200}
        top={240}
        width={200}
        delayTime={8.5}
        time={14}
      >
        <StaticImage
          placeholder="blurred"
          objectFit="contain"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_4.png"
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted left={110} top={25} width={110} delayTime={9} time={14}>
        <StaticImage
          placeholder="blurred"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_7.png"
          objectFit="contain"
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted left={90} top={125} width={90} delayTime={11} time={14}>
        <StaticImage
          placeholder="blurred"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_2.png"
          objectFit="contain"
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={90}
        top={330}
        width={90}
        delayTime={10.8}
        time={14}
      >
        <StaticImage
          placeholder="blurred"
          alt="trusted person"
          src="../../../assets/images/home_page_trusted_person_1.png"
          objectFit="contain"
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={120}
        top={448}
        width={120}
        delayTime={6}
        time={10}
      >
        <StaticImage
          placeholder="blurred"
          alt="logo"
          src="../../../assets/images/valspar_logo.png"
          width={120}
          height={38}
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={140}
        top={125}
        width={140}
        delayTime={8}
        time={10}
      >
        <StaticImage
          placeholder="blurred"
          alt="logo"
          src="../../../assets/images/dabella_logo.png"
          height={40}
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={140}
        top={270}
        width={140}
        delayTime={10}
        time={10}
      >
        <StaticImage
          placeholder="blurred"
          height={50}
          alt="vector"
          src="../../../assets/images/reneval_by_andersen_logo.png"
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={200}
        top={160}
        width={200}
        delayTime={14}
        time={10}
      >
        <StaticImage
          placeholder="blurred"
          alt="vector"
          src="../../../assets/images/certainteed_logo.png"
          height={40}
        />
      </StyledBoxTrusted>
      <StyledBoxTrusted
        left={200}
        top={350}
        width={200}
        delayTime={13}
        time={10}
      >
        <StaticImage
          placeholder="blurred"
          alt="vector"
          src="../../../assets/images/james_hardie_logo.png"
          height={40}
        />
      </StyledBoxTrusted>
    </StyledFade>
    <Box
      bg="neutral.0"
      position="absolute"
      right="-40px"
      top={0}
      w="42px"
      zIndex={200}
      h="100%"
    />
  </Box>
);

export default SlideDesktopAndTablet;
